var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('az-call-to-action',{attrs:{"dark":"","active":_vm.licitacao.podeAcessar,"outline":!_vm.licitacao.podeAcessar},on:{"click":function($event){return _vm.acessarPregao(_vm.licitacao)}}},[_vm._v(" Acessar ")])}
var staticRenderFns = []

export { render, staticRenderFns }